function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 3.732l7.5 1.666v7.352c0 2.887-1.958 6.247-7.24 8.203l-.26.097-.26-.097C6.457 18.997 4.5 15.637 4.5 12.75V5.398L12 3.732zm-6 2.87v6.148c0 2.075 1.366 4.898 6 6.698 4.634-1.8 6-4.623 6-6.698V6.602l-6-1.334-6 1.334z"
});

var SvgSecurity = function SvgSecurity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "3 4 18 16",
    fill: "#9193A9"
  }, props), _ref);
};

export default SvgSecurity;